export enum CascoRiskPackageCode {
    Alternative = 'BSC',
    Extended = 'SUPER3',
    Main = 'EKO3',
}
